import { render } from "./CoreData.vue?vue&type=template&id=70ef3036&scoped=true"
import script from "./CoreData.vue?vue&type=script&lang=js"
export * from "./CoreData.vue?vue&type=script&lang=js"

import "./CoreData.vue?vue&type=style&index=0&id=70ef3036&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ef3036"]])

export default __exports__